export default [
  {
    path: "/kys-egitime-katilim",
    name: "kys-egitime-katilim",
    component: () => import("@/views/kys-egitime-katilim/EgitimeKatilimListesi.vue"),
    meta: { public: false, title: "kys_egitime_katilim.baslik", yetki: { k: [1190902] } },
  },
  {
    path: "/kys-egitime-katilim/ekle",
    name: "kys-egitime-katilim-ekle",
    component: () => import("@/views/kys-egitime-katilim/EgitimeKatilimEkle.vue"),
    meta: { public: false, title: "kys_egitime_katilim.yeni_kayit", yetki: { k: [1190903] } },
  },
  {
    path: "/kys-egitime-katilim/duzelt/:uuid",
    name: "kys-egitime-katilim-duzelt",
    component: () => import("@/views/kys-egitime-katilim/EgitimeKatilimEkle.vue"),
    meta: { public: false, title: "kys_egitime_katilim.kayit_duzelt", yetki: { k: [1190904] } },
  },
]
